import { Check } from "lucide-react";
import { Section, Kicker, Reveal } from "./primitives";
import { BeamVisual } from "./BeamVisual";

const SPECS = [
  <>Qué <b className="text-cyan-300">tornillo tocar</b> y cuál no mover jamás.</>,
  <>Qué <b className="text-cyan-300">voltaje medir en milivoltios</b> antes de desarmar la óptica.</>,
  <>Cómo <b className="text-cyan-300">parametrizar métodos</b> de punto final, cinéticos y fijos.</>,
  <>Cómo <b className="text-cyan-300">calibrar curvas</b> y ejecutar pruebas de desempeño analítico con exactitud matemática.</>,
];

export const Solucion = () => (
  <Section id="solucion" band>
    <div className="grid items-center gap-12 lg:grid-cols-2">
      <Reveal>
        <Kicker num="02" label="La solución" />
        <span className="mb-4 block font-tech text-sm tracking-[0.35em] text-amber-400">
          TE PRESENTO: ABSORBANCIA PERFECTA
        </span>
        <h2 className="font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
          El mapa definitivo de ingeniería aplicada a la química clínica.
        </h2>
        <p className="mt-5 text-base leading-relaxed text-slate-400 md:text-lg">
          Absorbancia Perfecta es el programa formativo diseñado con un solo objetivo:
          llevarte de la mano para que domines con total solvencia la línea Mindray BA-88A
          en menos de 3 meses. Aquí no hay teoría de relleno. Es la ruta práctica de campo
          donde aprenderás exactamente:
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <BeamVisual />
      </Reveal>
    </div>

    <div className="mt-12 grid gap-4 sm:grid-cols-2">
      {SPECS.map((s, i) => (
        <Reveal key={i} delay={i * 0.08}>
          <div className="flex h-full items-start gap-3.5 rounded-2xl border border-cyan-400/15 bg-cyan-400/[0.04] p-5 transition-colors duration-300 hover:border-cyan-400/40">
            <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cyan-400/15 text-cyan-300">
              <Check className="h-3.5 w-3.5" />
            </span>
            <p className="text-sm leading-relaxed text-slate-300 sm:text-base">{s}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </Section>
);
